import { useSearchParams } from 'react-router-dom';

import { useAnonymousAnalyticsTrackPage } from '../../common/analytics';
import { IconLogInCircle } from '../../common/design-tokens/Icons';
import { t } from '../../localization/LocaleContext';
import { useVerifyEmail } from '../../remoteData/unauthenticated';
import LoadingScreen from '../LoadingScreen';
import {
  Container,
  Email,
  LoginLink,
  Subtitle,
  Title,
} from './styledComponents';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('t') ?? undefined;

  useAnonymousAnalyticsTrackPage({
    name: 'Verify Email',
    category: 'Public',
  });

  const { data: verifyEmail, error: verifyEmailError } = useVerifyEmail(token);

  if (!token || verifyEmailError) {
    return (
      <Container>
        <Title>{t('general_invalid_link_title')}</Title>
        <Subtitle>{t('general_invalid_link_text')}</Subtitle>
      </Container>
    );
  }

  if (!verifyEmail) {
    return <LoadingScreen />;
  }

  return (
    <Container>
      <Title>{t('email_verification_success_title')}</Title>
      <Subtitle>
        {t('email_verification_success_subtitle', {
          email: <Email>{verifyEmail.email}</Email>,
        })}
      </Subtitle>
      <LoginLink to="/dashboard">
        <IconLogInCircle aria-hidden /> {t('email_verification_login_link')}
      </LoginLink>
    </Container>
  );
}
